import { render, staticRenderFns } from "./publication.vue?vue&type=template&id=b8ed6572&"
import script from "./publication.vue?vue&type=script&lang=js&"
export * from "./publication.vue?vue&type=script&lang=js&"
import style0 from "./publication.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8ed6572')) {
      api.createRecord('b8ed6572', component.options)
    } else {
      api.reload('b8ed6572', component.options)
    }
    module.hot.accept("./publication.vue?vue&type=template&id=b8ed6572&", function () {
      api.rerender('b8ed6572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/publication.vue"
export default component.exports